import React from "react";
import { Button, MessageBar, MessageBarActions, MessageBarBody } from "@fluentui/react-components";
import { usePastDueBannerViewModel } from "./PastDueBanner.ViewModel";
import { usePastDueBannerText } from "./PastDueBanner.i18n";

/** Across the app while a payment is past due, so the user can fix the card before the plan lapses. */
const PastDueBanner: React.FC = () => {
  const vm = usePastDueBannerViewModel();
  const text = usePastDueBannerText();

  if (!vm.isVisible) return null;

  return (
    <MessageBar intent="warning" layout="multiline">
      <MessageBarBody>
        {vm.portalError ? text.portalError(vm.portalError) : text.message}
      </MessageBarBody>
      <MessageBarActions>
        <Button appearance="primary" size="small" onClick={vm.updateCard} disabled={vm.isOpeningPortal}>
          {vm.isOpeningPortal ? text.opening : text.action}
        </Button>
      </MessageBarActions>
    </MessageBar>
  );
};

export default PastDueBanner;
